<template>
  <span  v-b-tooltip.hover :title="$t('page.requiredField')" class="required-icon"><i class="fas fa-asterisk required-field"></i></span>
</template>

<script>
  export default {
    name: 'RequiredField'
  }
</script>

<style scoped>
  .required-field{
    font-size: xx-small;
    vertical-align: top;
  }

  .required-icon{
    color: #7d0000
  }

</style>
